export default {"src":"/_next/static/media/mypage.d9de4563.svg","height":25,"width":26};